// Approved retailer snapshot. Automatic spreadsheet updates are not connected.
(() => {
  'use strict';
  const stores = JSON.parse(document.getElementById('store-data').textContent);
  const search = document.getElementById('store-search');
  const query = document.getElementById('store-query');
  const state = document.getElementById('store-state');
  const count = document.getElementById('store-count');
  const list = document.getElementById('store-list');
  const empty = document.getElementById('store-empty');
  const clear = document.getElementById('clear-search');
  const status = document.getElementById('map-status');
  const mapElement = document.getElementById('store-map');
  const items = new Map(Array.from(list.children, item => [item.dataset.storeId, item]));
  const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const indexed = new Map(stores.map(store => [store.id, normalize([store.name, store.address, store.city, store.state, store.stateName].join(' '))]));
  let map, layer, visible = stores;
  const markers = new Map();

  function highlight(ids) {
    items.forEach((item, id) => item.classList.toggle('is-selected', ids.includes(id)));
  }

  function popup(storesInGroup) {
    const wrapper = document.createElement('div');
    storesInGroup.forEach(store => {
      const entry = document.createElement('div');
      entry.className = 'popup-store';
      const title = document.createElement('strong');
      title.textContent = store.name;
      const address = document.createElement('p');
      address.textContent = store.address;
      entry.append(title, address);
      if (store.addressPrecision !== 'street') {
        const note = document.createElement('p');
        note.className = 'store-approx';
        note.textContent = 'Approximate area. Open Maps to confirm the store location.';
        entry.append(note);
      }
      const link = document.createElement('a');
      link.className = 'store-directions';
      link.href = store.mapsUrl;
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = 'Open in Maps ↗';
      entry.append(link);
      wrapper.append(entry);
    });
    return wrapper;
  }

  function drawMap() {
    if (!map) return;
    layer.clearLayers();
    markers.clear();
    const groups = new Map();
    visible.forEach(store => {
      const key = `${store.lat},${store.lng}`;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(store);
    });
    groups.forEach(group => {
      const approximate = group.some(store => store.addressPrecision !== 'street');
      const size = group.length > 1 ? 26 : 16;
      const label = group.length > 1 ? `${group.length} retailers in ${group[0].city}` : group[0].name;
      const marker = L.marker([group[0].lat, group[0].lng], {
        icon: L.divIcon({ className: `retailer-marker${approximate ? ' is-approximate' : ''}`, html: group.length > 1 ? String(group.length) : '', iconSize: [size, size], iconAnchor: [size / 2, size / 2] }),
        title: label,
        keyboard: true
      }).bindPopup(popup(group), { maxWidth: 300 }).addTo(layer);
      marker.getElement().setAttribute('aria-label', label + (approximate ? ', approximate area' : ''));
      marker.on('click', () => highlight(group.map(store => store.id)));
      group.forEach(store => markers.set(store.id, marker));
    });
    if (visible.length) {
      map.fitBounds(visible.map(store => [store.lat, store.lng]), { padding: [35, 35], maxZoom: visible.some(store => store.addressPrecision !== 'street') ? 11 : 13, animate: false });
    }
  }

  function update() {
    const terms = normalize(query.value).split(' ').filter(Boolean);
    visible = stores.filter(store => (!state.value || store.state === state.value) && terms.every(term => indexed.get(store.id).includes(term)));
    const ids = new Set(visible.map(store => store.id));
    items.forEach((item, id) => { item.hidden = !ids.has(id); item.classList.remove('is-selected'); });
    empty.hidden = visible.length > 0;
    count.textContent = `${visible.length} ${visible.length === 1 ? 'store' : 'stores'}${state.value ? ` in ${state.selectedOptions[0].textContent}` : ''}`;
    clear.hidden = !query.value && !state.value;
    document.querySelector('.locator-results').scrollTop = 0;
    drawMap();
  }

  function reset() {
    query.value = '';
    state.value = '';
    update();
    query.focus({ preventScroll: true });
  }

  if (window.L) {
    try {
      map = L.map(mapElement, { scrollWheelZoom: false, zoomControl: true }).setView([38.5, -98], 4);
      layer = L.layerGroup().addTo(map);
      let tileLoaded = false, tileFailed = false, tileTimer;
      const tiles = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' });
      tiles.on('loading', () => {
        tileLoaded = false;
        tileFailed = false;
        clearTimeout(tileTimer);
        tileTimer = setTimeout(() => {
          if (!tileLoaded && !tileFailed) { status.textContent = 'The map is taking a little longer to load. You can still use the store list.'; status.hidden = false; }
        }, 8000);
      });
      tiles.on('tileload', () => { tileLoaded = true; status.hidden = true; });
      tiles.on('tileerror', () => {
        tileFailed = true;
        if (!tileLoaded) { status.textContent = 'The map is unavailable right now. Use the store list or Open in Maps links.'; status.hidden = false; }
      });
      tiles.addTo(map);
      list.querySelectorAll('.store-select').forEach(button => {
        button.disabled = false;
        button.addEventListener('click', () => {
          const store = stores.find(item => item.id === button.dataset.store);
          const marker = markers.get(store.id);
          if (!marker) return;
          highlight([store.id]);
          map.setView(marker.getLatLng(), store.addressPrecision === 'street' ? 14 : 11, { animate: false });
          marker.openPopup();
        });
      });
    } catch (error) {
      if (map) map.remove();
      map = null;
      status.textContent = 'The map is unavailable right now. Use the store list or Open in Maps links.';
    }
  } else {
    status.textContent = 'The map is unavailable right now. Use the store list or Open in Maps links.';
  }

  query.addEventListener('input', update);
  state.addEventListener('change', update);
  search.addEventListener('submit', event => { event.preventDefault(); update(); });
  clear.addEventListener('click', reset);
  document.querySelector('.reset-search').addEventListener('click', reset);
  search.querySelectorAll('[disabled]').forEach(control => { control.disabled = false; });
  update();
})();

/* Shared dropdown navigation for desktop and mobile. */
(() => {
  const header = document.querySelector('header.numuti-header');
  if (!header) return;
  const toggle = header.querySelector('.mobile-menu-toggle');
  const navigation = header.querySelector('#numuti-mobile-menu');
  if (!toggle || !navigation) return;
  const mobile = window.matchMedia('(max-width: 767px)');
  let open = false;

  function render() {
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    navigation.hidden = !open;
  }
  function close(returnFocus = false) {
    open = false;
    render();
    if (returnFocus) toggle.focus();
  }

  toggle.hidden = false;
  header.classList.add('mobile-nav-ready');
  render();
  toggle.addEventListener('click', () => {
    open = !open;
    render();
  });
  toggle.addEventListener('keydown', event => {
    if (event.key !== 'ArrowDown') return;
    event.preventDefault();
    open = true;
    render();
    navigation.querySelector('a[href]')?.focus();
  });
  navigation.addEventListener('click', event => {
    if (event.target.closest('a[href]')) close();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && open) {
      event.preventDefault();
      close(true);
    }
  });
  document.addEventListener('click', event => {
    if (open && !header.contains(event.target)) close();
  });
  header.addEventListener('focusout', () => {
    requestAnimationFrame(() => {
      if (open && !header.contains(document.activeElement)) close();
    });
  });
  mobile.addEventListener('change', () => {
    const focusWasInNavigation = navigation.contains(document.activeElement);
    close(focusWasInNavigation);
  });
})();

